var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCardPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.58 0 0 3.58 0 8C0 12.42 3.58 16 8 16C12.42 16 16 12.42 16 8C16 3.58 12.42 0 8 0ZM10.5 9H9V10.5C9 11.05 8.55 11.5 8 11.5C7.45 11.5 7 11.05 7 10.5V9H5.5C4.95 9 4.5 8.55 4.5 8C4.5 7.45 4.95 7 5.5 7H7V5.5C7 4.95 7.45 4.5 8 4.5C8.55 4.5 9 4.95 9 5.5V7H10.5C11.05 7 11.5 7.45 11.5 8C11.5 8.55 11.05 9 10.5 9Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardPlus);
export default __webpack_public_path__ + "static/media/credit-card-plus.29bfc966f9b9f59b39b4204c2e3fcfa0.svg";
export { ForwardRef as ReactComponent };